// function handleResponse(){var response=JSON.parse(this.responseText);if(response=response["product-outcome-codes"].match(/<outcome_codes>(.*?)<\/outcome_codes>/g),response=response[0].replace(/<\/?outcome_codes>/g,""),response=JSON.parse(response),response.length){var codes=document.querySelectorAll("[data-outcome-code]");codes.length&&codes.forEach(function(el){var match=response.find(o=>o.heading.replace(/\s/g,"")===el.getAttribute("data-outcome-code").replace(/\s/g,""));if(match){el.setAttribute("title",match.heading+" \u2014 "+match.definition)}})}}const request=new XMLHttpRequest;request.addEventListener("load",handleResponse),request.open("GET","/?sections=product-outcome-codes",!0),request.send();

function handleResponse() {
  var response = JSON.parse(this.responseText);
  var response = response["product-outcome-codes"]
    .match(/<outcome_codes>(.*?)<\/outcome_codes>/g);
  response = response[0].replace(/<\/?outcome_codes>/g, "");
  response = JSON.parse(response);

  if (!response.length) return;

  document.querySelectorAll("[data-outcome-code]").forEach(function (el) {
    var match = response.find(function (o) {
      return o.heading.replace(/\s/g, "") ===
             el.getAttribute("data-outcome-code").replace(/\s/g, "");
    });
    if (!match) return;

    // title attribute ki jagah custom tooltip element
    var tip = document.createElement("span");
    tip.className = "tip-custom";
    tip.textContent = match.heading + " \u2014 " + match.definition;
    el.classList.add("has-tip");
    el.appendChild(tip);
  });
}

var request = new XMLHttpRequest;
request.addEventListener("load", handleResponse);
request.open("GET", "/?sections=product-outcome-codes", true);
request.send();